import React from "react";
import "./V2Glass.css";

function joinClasses(...classes: Array<string | undefined>): string {
    return classes.filter(Boolean).join(" ");
}

interface V2GlassPanelProps extends React.HTMLAttributes<HTMLElement> {
    children: React.ReactNode;
}

export function V2GlassPanel({children, className, ...props}: V2GlassPanelProps) {
    return (
        <section className={joinClasses("v2-glass-panel", className)} {...props}>
            {children}
        </section>
    );
}

interface V2GlassSurfaceProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
}

export function V2GlassSurface({children, className, ...props}: V2GlassSurfaceProps) {
    return (
        <div className={joinClasses("v2-glass-surface", className)} {...props}>
            {children}
        </div>
    );
}

interface V2GlassChipProps extends React.HTMLAttributes<HTMLSpanElement> {
    children: React.ReactNode;
}

export function V2GlassChip({children, className, ...props}: V2GlassChipProps) {
    return (
        <span className={joinClasses("v2-glass-chip", className)} {...props}>
            {children}
        </span>
    );
}
